import React, { useState, useEffect } from "react"
import { graphql, Link } from "gatsby" 
//import { graphql } from "gatsby"
//import { Link } from "gatsby"
import { blogs } from "../data/blogs"
import Experts from "../components/Experts"
import SEO from "../components/SEO"
import Hero from "../components/Hero"
import Infobar from "../components/Infobar"
import Location from "../components/Location"
import Reviews from "../components/Reviews"
import Schedule from "../components/Schedule"
import Services from "../components/Services"
import teamImage from "../assets/images/team/team.jpg"
//import popupImage from "../assets/images/youre-invited-open-houseV3.webp" 

function HomePage({ data, location }) {
  const reviews = data.reviews.nodes
  const services = data.services.nodes
  const experts = data.experts.nodes

  const [showPopup, setShowPopup] = useState(false)

/*  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem("homePopupShown")
    if (!hasSeenPopup) {
      setShowPopup(true)
      sessionStorage.setItem("homePopupShown", "true")
    }
  }, [])*/
    useEffect(() => {
  setShowPopup(true)
}, [])

const latestBlogs = [...blogs]
  .sort((a, b) => new Date(b.date) - new Date(a.date))
  .slice(0, 3)
  
  return (
    <div>
      <SEO
  location={location}
  title="Chiropractor in West Loop Chicago | Urban Care Chiropractic" 
  description="Urban Care Chiropractic offers trusted chiropractic, physical therapy, massage therapy, acupuncture, and cupping services in West Loop, Chicago."
/>

      {false && (
        <div className="homepage-popup-overlay" onClick={() => setShowPopup(false)}>
          <div
            className="homepage-popup-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="homepage-popup-close"
              onClick={() => setShowPopup(false)}
              aria-label="Close popup"
            >
              ×
            </button>
			<a
  href="https://www.eventbrite.com/e/spring-refresh-open-house-tickets-1986827460418?aff=ebdssbdestsearch"
  target="_blank"
  rel="noopener noreferrer"
>
            <img
              src={popupImage}
              alt="Urban Care Chiropractic Open House Invitation"
              className="homepage-popup-image"
            />
			</a>			
          </div>
        </div> 
      )}

      <section className="container my-5 px-3 page-content" id="homepage-intro">
        <h1 className="mb-2">Chiropractor in West Loop</h1>
        <h2 className="mb-3">We Are a Trusted Chiropractor Near You</h2>

        <p className="mb-3">
          At Urban Care Chiropractic, we believe that true wellness goes beyond the
          absence of symptoms. Our clinic is dedicated to helping you achieve optimal
          health through personalized, holistic care. Whether you are an athlete
          looking to enhance performance, an office worker battling poor posture, or
          someone seeking relief from chronic pain, our team is here to support your
          journey.
        </p>

        <p className="mb-5">
          We understand that choosing the right provider is a crucial decision for
          your health. That is why we strive to be the most reliable and effective
          chiropractor in West Loop near you, offering a path toward a pain-free,
          active, and balanced life.
        </p>

        <h2 className="mb-3">Chiropractic and Other Services in Our West Loop, Chicago Clinic</h2>
        <p className="mb-4">
          We offer a comprehensive suite of services designed to address the root cause
          of your discomfort rather than just masking the symptoms. Our integrated
          approach ensures you receive the right chiropractic treatment in Chicago for
          your specific needs.
        </p>

        <div className="row g-4 text-center services-grid">
          <div className="col-12 col-lg">
            <h3 className="h5">Chiropractic Care</h3>
            <p className="mb-0">
              Our core service focuses on diagnosing and treating neuromuscular disorders,
              specifically through manual adjustment and manipulation of the spine. Our
              methods are designed to restore proper alignment, improve nervous system
              function, and facilitate the body’s natural ability to heal itself.
            </p>
          </div>

          <div className="col-12 col-lg">
            <h3 className="h5">Cupping</h3>
            <p className="mb-0">
              We use cupping therapy to help with pain, inflammation, blood flow, and
              relaxation. This ancient technique complements our modern treatments by
              acting as a type of deep-tissue massage, helping to decompress muscles and
              connective tissue to speed up recovery.
            </p>
          </div>

          <div className="col-12 col-lg">
            <h3 className="h5">Massage Therapy</h3>
            <p className="mb-0">
              Our massage therapy services are tailored to work in tandem with chiropractic
              care. By targeting soft tissue tension, we can help retain your adjustments
              longer, reduce stress, and improve overall circulation. It is an essential
              component of chiropractic therapy in Chicago for many of our patients.
            </p>
          </div>

          <div className="col-12 col-lg">
            <h3 className="h5">Physical Therapy</h3>
            <p className="mb-0">
              To ensure long-term relief, we incorporate physical therapy modalities that
              strengthen the body and correct movement patterns. Our goal is to rehabilitate
              injuries and provide you with the tools to prevent future issues, ensuring
              your body functions at its best.
            </p>
          </div>

          <div className="col-12 col-lg">
            <h3 className="h5">Acupuncture</h3>
            <p className="mb-0">
              Our acupuncture services provide a holistic alternative for pain management by
              stimulating the body’s natural healing response. Acupuncture targets the
              nervous system to release natural painkillers and improve circulation. This
              treatment is highly effective for reducing stress, alleviating chronic pain,
              and treating headaches, making it a perfect complement to our chiropractic and
              rehabilitation plans.
            </p>
          </div>
        </div>
      </section>

      <Schedule />
      <Reviews reviews={reviews} />
      <Experts experts={experts} team={teamImage} />
      <Services services={services} />

      <section className="container my-5 px-3" id="homepage-benefits">
        <h2>Benefits of Seeing a Chiropractor in Chicago</h2>
        <p>By visiting a chiropractor you are investing in your health by increasing longevity and improving daily function and quality of life.</p>

        <div className="wellness-grid">
          <div>
            <h3>Holistic Wellness</h3>
            <p>Chiropractic care is an integral part of a complete self-care and wellness routine.</p>
          </div>

          <div>
            <h3>Beyond Pain Relief</h3>
            <p>We focus on the root causes of dysfunction, meaning care is not just about treating immediate pain, but correcting the source.</p>
          </div>

          <div>
            <h3>Preventative Strategy</h3>
            <p>Regular visits serve as maintenance care, helping to prevent new injuries before they occur.</p>
          </div>

          <div>
            <h3>Enhanced Movement</h3>
            <p>Treatment significantly improves mobility and flexibility, allowing your body to move fluidly.</p>
          </div>

          <div>
            <h3>Youthful Vitality</h3>
            <p>Many patients report feeling their actual age—or even younger—after restoring proper alignment.</p>
          </div>

          <div>
            <h3>Restored Normalcy</h3>
            <p>We help you feel "back to normal," removing the friction and stiffness from your daily life.</p>
          </div>

          <div>
            <h3>Active Living</h3>
            <p>Our care empowers you to work out and participate in the activities you love without being sidelined by pain.</p>
          </div>

          <div>
            <h3>Mental Well-Being</h3>
            <p>By reducing physical stress and pain, chiropractic care often leads to improved mental health and reduced anxiety.</p>
          </div>
        </div>

        <h2>Why Trust Our West Loop, Chicago Chiropractic Clinic</h2>
        <p>We know you have choices when it comes to your health, but we pride ourselves on offering an experience that stands apart.</p>
        <div className="wellness-grid">
          <div>
            <h3>A Sanctuary in the City</h3>
            <p>We maintain a calming environment that allows you to decompress the moment you walk through our doors.</p>
          </div>

          <div>
            <h3>Professional Excellence</h3>
            <p>Our clinic adheres to the highest professional standards while remaining warm and inviting.</p>
          </div>

          <div>
            <h3>Patient-First Comfort</h3>
            <p>We prioritize making every patient feel comfortable and completely at ease during their visit.</p>
          </div>

          <div>
            <h3>Enhanced Movement</h3>
            <p>Treatment significantly improves mobility and flexibility, allowing your body to move fluidly.</p>
          </div>

          <div>
            <h3>A Positive Step</h3>
            <p>Choosing us means you have made the right step towards fixing your problem.</p>
          </div>

          <div>
            <h3>Educational Approach</h3>
            <p>We provide you with the information you need to make an educated decision regarding treatments.</p>
          </div>
        </div>

        <div className="mt-5">
          <h2>Take Control of Your Health</h2>

          <p>At Urban Care Chiropractic, we are committed to partnering with you on your journey toward better health through hands-on care and compassionate service. Whether you are seeking immediate relief from an injury or long-term maintenance for a balanced lifestyle, our West Loop team is ready to help you unlock your body's full potential.</p>
          <p>For a chiropractic adjustment in Chicago, IL contact Urban Care Chiropractic today.</p>

          <p><strong>Call us at 312-841-5500.</strong></p>

          <h3>Frequently Asked Questions</h3>

          <ul className="list-group">
            <li className="list-group-item">
              <p><strong>What should I expect during my first visit?</strong></p>
              <p>
                Your initial visit is all about understanding your unique needs. We will start with a comprehensive consultation to discuss your health history and current goals, followed by a physical assessment to identify the root cause of your symptoms. In most cases, digital x-rays are taken to assess spine and joint health and alignment. On day one, you can also expect to receive treatment to get you started on the path to relief and improved health.
              </p>
            </li>

            <li className="list-group-item">
              <p><strong>Is a chiropractic adjustment painful?</strong></p>
              <p>
                Most patients find adjustments to be a relieving experience rather than a painful one. While you may feel some pressure or hear a "popping" sound (which is simply gas releasing from the joint), the procedure is generally comfortable. Our team prioritizes gentle techniques to ensure you feel at ease throughout the process.
              </p>
            </li>

            <li className="list-group-item">
              <p><strong>Can chiropractic care help with issues other than back pain?</strong></p>
              <p>
                Absolutely. While we are experts in treating back pain, our holistic approach addresses the entire musculoskeletal system. We frequently treat headaches, neck pain, sciatica, joint stiffness, and sports injuries, helping to improve your overall mobility and wellness.
              </p>
            </li>
          </ul>
        </div>
      </section>

      <Location />
      <aside
        className="container-fluid d-flex align-items-center justify-content-center bg-light parallax text-light"
        id="quote"
        style={{ minHeight: "30vh" }}
      >
        <div className="row">
          <div className="col text-center">
            <figure>
              <blockquote
                className="blockquote"
                style={{ color: "var(--bs-secondary)" }}
              >
                <p>
                  Don’t miss out on your ticket to living a healthier and
                  happier lifestyle.
                </p>
              </blockquote>
            </figure>
          </div>
        </div>
      </aside>
	  
	  <section className="container my-5 px-3" id="homepage-blog">
  <h2>Latest Blog Posts</h2>

  <div className="blog-grid">
    {latestBlogs.map(blog => (
      <article className="blog-card" key={blog.link}>
        <Link to={blog.link}>
          <img src={blog.image} alt={blog.title} />
        </Link>

        <div className="blog-card-content">
          <h3>
            <Link to={blog.link}>{blog.title}</Link>
          </h3>

          <p>{blog.excerpt}</p>
          <small>{blog.date} | By Dr. Kenny Snook</small>
        </div>
      </article>
    ))}
  </div>
</section>
	  
    </div>

  )
}

export default React.memo(HomePage)

export const query = graphql`
  query {
    posts: allSanityPost {
      nodes {
        date
        description
        id
        link
        title
      }
    } 
    reviews: allSanityReview {
      nodes {
        id
        demo
        name
        rating
        review
        photo {
          asset {
            fluid(maxWidth: 400) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
    }
    services: allSanityServices {
      nodes {
        id
        name
        description
        demo
        image {
          asset {
            fluid(maxWidth: 400) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
    }
    experts: allSanityExperts {
      nodes {
        id
        description
        motto
        name
        specialty
        image {
          asset {
            fluid(maxWidth: 400) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
    }
    images: allSanityImages(filter: { active: { eq: true } }) {
      nodes {
        id
        title
        subtitle
        active
        image {
          asset {
            metadata {
              dimensions {
                height
                width
              }
            }
            fluid(maxWidth: 1200) {
              ...GatsbySanityImageFluid
            }
          }
          hotspot {
            y
            x
          }
          crop {
            bottom
            left
            right
            top
          }
        }
      }
    }
  }
`
